import "../../../FhPagination.css";
import { ref, watch, openBlock, createElementBlock, createVNode, withCtx, createTextVNode, toDisplayString, createElementVNode, unref, Fragment, renderList, createBlock } from "vue";
import FhText from "../../FhText/FhText.mjs";
import FhButton from "../../Buttons/FhButton/FhButton.mjs";
import FhIconButton from "../../Buttons/FhIconButton/FhIconButton.mjs";
import chevronLeft from "../../../icons/chevronLeft.mjs";
import chevronRight from "../../../icons/chevronRight.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = { class: "fh-pagination" };
const _sfc_main = {
  __name: "FhPagination",
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    modelValue: {
      type: Number,
      default: 1
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const currentPage = ref(props.modelValue);
    watch(
      () => props.modelValue,
      (newVal) => {
        currentPage.value = newVal;
      }
    );
    const selectPage = (page) => {
      currentPage.value = page;
      emit("update:modelValue", page);
    };
    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value -= 1;
        emit("update:modelValue", currentPage.value);
      }
    };
    const nextPage = () => {
      if (currentPage.value < props.totalPages) {
        currentPage.value += 1;
        emit("update:modelValue", currentPage.value);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(FhText, {
          tag: "span",
          color: "subtle",
          variant: "body-md"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(currentPage.value) + " of " + toDisplayString(__props.totalPages), 1)
          ]),
          _: 1
        }),
        createElementVNode("nav", null, [
          createVNode(FhIconButton, {
            onClick: prevPage,
            variant: "plain",
            size: "sm",
            icon: unref(chevronLeft),
            disabled: currentPage.value === 1,
            "data-test-id": "pagination-prev"
          }, {
            default: withCtx(() => [
              createTextVNode(" Previous ")
            ]),
            _: 1
          }, 8, ["icon", "disabled"]),
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.totalPages, (page) => {
            return openBlock(), createBlock(FhButton, {
              key: page,
              onClick: ($event) => selectPage(page),
              variant: "plain",
              size: "sm",
              selected: page === currentPage.value
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(page), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "selected"]);
          }), 128)),
          createVNode(FhIconButton, {
            onClick: nextPage,
            variant: "plain",
            size: "sm",
            icon: unref(chevronRight),
            disabled: currentPage.value === __props.totalPages,
            "data-test-id": "pagination-next"
          }, {
            default: withCtx(() => [
              createTextVNode(" Next ")
            ]),
            _: 1
          }, 8, ["icon", "disabled"])
        ])
      ]);
    };
  }
};
const FhPagination = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-12a8f354"]]);
export {
  FhPagination as default
};
//# sourceMappingURL=FhPagination.mjs.map
